import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as _ from 'lodash';
import React from 'react';
import { DialogForm, FieldInfo } from '../../components/DialogForm';
import { EnableServiceFormDataConfig, EditEnableServiceFormDataConfig } from './formDataConfig';
import tooltipInfo from '../../utils/tooltipInfo.json';

const useStyles = makeStyles(theme => ({
  dialog: {
    width: '100%'
  },
  dialogTitle: {
    padding: theme.spacing(2),
    borderBottom: '1px solid'
  },
  progress: {
    color: theme.palette.background.paper
  },
  textField: {
    width: '90%'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  },
  headers: {
    color: theme.palette.text.secondary
  },
  tooltip: {
    opacity: 0.4,
    padding: 0,
    minWidth: '15px',
    top: '-3px'
  }
}));

interface ParticipantServiceProps {
  participant: any;
  dialogOpen: true | false;
  handleDialogClose: any;
  formData: any;
  edit: true | false;
  subscribedParticipantRefresh: any;
  allAuthentications: any;
  supportUser: true | false;
  formInfo: any;
  authContextList: any;
  getLatestValues: (data: any) => void;
  handleOperationDataChange: (e: any, operation: any, field: string, authList?: any) => void;
  handleDialogSubmit: (FormData: any) => void;
  isServiceAuthentication: (value: any) => void;
  setServiceAuthContext: (auth: any) => void;
  serviceAuthContext?: any;
  serviceAuthentication?: any;
  domain?: any;
  setDomain: (domain: any) => void;
  setRequireTransform: (value: any) => void;
  requireTransform: any;
  setProviderCustomerCodePath: (value: any) => void;
  providerCustomerCodePath: any;
  aggregatorCode?: any;
  authContext?: any;
}

const EnableServiceDialog = (props: ParticipantServiceProps) => {
  const {
    handleOperationDataChange,
    formInfo,
    getLatestValues,
    handleDialogSubmit,
    handleDialogClose,
    authContextList,
    setDomain,
    domain,
    setRequireTransform,
    requireTransform,
    setProviderCustomerCodePath,
    providerCustomerCodePath
  } = props;

  let { participantCode, participantType } = props.participant;
  const classes = useStyles();

  let aggregatorType: any = '';
  if (participantType === 'PROVIDER') {
    aggregatorType = 'AGGREGATOR';
  } else if (participantType === 'CUSTOMER') {
    aggregatorType = 'CUSTOMER_AGGREGATOR';
  }

  const handleRequireTransformChange = (value: string) => {
    setRequireTransform(value);
  };

  const handleDomainChange = (e: any) => {
    setDomain(e.target.value);
  };

  const handleProviderCustomerCodePathChange = (e: any) => {
    setProviderCustomerCodePath(e.target.value);
  };

  const getDataConfig = () => {
    if (
      props.formData !== undefined &&
      (props.formData.workflowCode === 'freightTracking' || formInfo.workflowCode === 'freightTracking')
    ) {
      let data = [...EnableServiceFormDataConfig[participantType]];
      data.push({
        key: 'tid',
        label: 'Customer TID',
        defaultValue: '',
        type: 'text',
        size: 6,
        required: true
      });
      return [...data];
    }

    if (props.edit) {
      return EditEnableServiceFormDataConfig[participantType];
    } else return EnableServiceFormDataConfig[participantType];
  };

  return (
    <div>
      <DialogForm
        openFn={props.dialogOpen}
        closeFn={handleDialogClose}
        dialogId="enable-service-dialog"
        title={`Enable Service - ${participantCode}`}
        dataConfig={getDataConfig()}
        handleDialogClose={handleDialogClose}
        handleDialogSubmit={handleDialogSubmit}
        submitlabel="Enable Service"
        getLatestValues={getLatestValues}
        data={props.formData}
        supportUser={props.supportUser}
        maxWidth="lg"
      >
        {formInfo.workflowCode !== 'freightTracking' ||
        (props.edit && props.formData.workflowCode !== 'freightTracking') ? (
          <>
            <Box m={1}>
              <Box className={classes.grid}>
                <Typography variant="subtitle1" style={{ padding: '8px' }}>
                  Operations
                </Typography>
              </Box>
              <Box className={classes.grid} style={{ padding: '8px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={2}>
                    <Typography className={classes.headers}>Name</Typography>
                  </Grid>
                  <Grid item xs={props.participant.participantType === 'CUSTOMER' ? 5 : 4}>
                    <Typography className={classes.headers}>URL</Typography>
                  </Grid>
                  {props.participant.participantType !== 'CUSTOMER' ? (
                    <Grid item xs={1}>
                      <Typography className={classes.headers}>
                        No Ops
                        {tooltipInfo?.noOps && <FieldInfo className={classes.tooltip} title={tooltipInfo?.noOps} />}
                      </Typography>
                    </Grid>
                  ) : (
                    ''
                  )}
                  <Grid item xs={1}>
                    <Typography className={classes.headers}>Use Default Auth</Typography>
                  </Grid>

                  <Grid item xs={2}>
                    <Typography className={classes.headers}>Auth Context</Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box m={2}>
                {props.participant.participantType === 'CUSTOMER' && (
                  <Grid container style={{ width: '100%' }} spacing={3} alignItems="flex-end">
                    <Grid item xs={2} justify="center" alignItems="flex-end">
                      <Typography noWrap>
                        Domain
                        {tooltipInfo?.domain && <FieldInfo className={classes.tooltip} title={tooltipInfo?.domain} />}
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        data-id="domainUrl"
                        id="domainUrl"
                        disabled={
                          props?.supportUser ? props?.supportUser : _.isEmpty(Object.keys(formInfo?.operations || {}))
                        }
                        className={classes.textField}
                        value={domain || ''}
                        onChange={e => handleDomainChange(e)}
                        // disabled={props?.supportUser}
                      ></TextField>
                    </Grid>
                  </Grid>
                )}
                {formInfo?.workflowCode &&
                  Object.keys(formInfo?.operations || {}).map((operationCode: any) => (
                    <Grid container spacing={3} alignItems="flex-end">
                      <Grid item xs={2} justify="center" alignItems="flex-end">
                        <Typography>{formInfo.operations[operationCode].operationName}</Typography>
                      </Grid>

                      <Grid item xs={props.participant.participantType === 'CUSTOMER' ? 5 : 4}>
                        <TextField
                          data-id={`parameter-${operationCode}`}
                          id={`parameter-${operationCode}`}
                          className={classes.textField}
                          value={formInfo?.operations?.[operationCode] ? formInfo.operations[operationCode].url : ''}
                          onChange={e => handleOperationDataChange(e, operationCode, 'url')}
                          disabled={
                            props?.supportUser
                              ? props?.supportUser
                              : formInfo?.operations?.[operationCode]
                              ? formInfo.operations[operationCode].noOps
                              : false
                          }
                        ></TextField>
                      </Grid>

                      {props.participant.participantType !== 'CUSTOMER' && (
                        <Grid item xs={1}>
                          <Checkbox
                            data-id="noOps"
                            checked={
                              formInfo?.operations?.[operationCode] ? formInfo.operations[operationCode].noOps : false
                            }
                            onChange={e => handleOperationDataChange(e, operationCode, 'noOps')}
                            name="NoOps"
                            color="primary"
                            disabled={props?.supportUser}
                          />
                        </Grid>
                      )}

                      <Grid item xs={1}>
                        <Checkbox
                          data-id="useAuthContext"
                          checked={
                            formInfo?.operations?.[operationCode]
                              ? formInfo.operations[operationCode].useAuthContext
                              : false
                          }
                          onChange={e => handleOperationDataChange(e, operationCode, 'useAuthContext')}
                          name="useAuthContext"
                          color="primary"
                          // disabled={formInfo.operations[operationCode].useAggregator}
                          disabled={props?.supportUser}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        {/* <Typography noWrap>Aggregator Authentication To use</Typography> */}
                        <Select
                          id="Operation-AuthContext-Select"
                          className={classes.textField}
                          label={'Auth Context'}
                          value={formInfo.operations[operationCode].authContext}
                          onChange={e => handleOperationDataChange(e, operationCode, 'authContext')}
                          disabled={
                            props?.supportUser ? props?.supportUser : formInfo.operations[operationCode].useAuthContext
                          }
                        >
                          {authContextList.length > 0 &&
                            authContextList?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
                        </Select>
                      </Grid>

                      {/* Aggregator section ends --> */}
                    </Grid>
                  ))}
              </Box>

              {participantType === 'PROVIDER' ? (
                <Box m={1}>
                  <Box className={classes.grid}>
                    <Typography id="subtitle1" variant="subtitle1" style={{ padding: '8px' }}>
                      Enable Transformation
                    </Typography>
                  </Box>
                  <Box m={2}>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography noWrap>Require Transform</Typography>

                        <RadioGroup row className={classes.textField} defaultValue={'no'} value={requireTransform}>
                          {
                            <FormControlLabel
                              id="ServiceYes"
                              key={'YES'}
                              value={'yes'}
                              labelPlacement="end"
                              control={<Radio color="primary" />}
                              label={'Yes'}
                              onChange={e => handleRequireTransformChange('yes')}
                            />
                          }
                          {
                            <FormControlLabel
                              id="ServiceNo"
                              key={'No'}
                              value={'no'}
                              labelPlacement="end"
                              control={<Radio color="primary" />}
                              label={'no'}
                              onChange={e => handleRequireTransformChange('no')}
                            />
                          }
                        </RadioGroup>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          data-id="providerCustomerCodePath"
                          id="providerCustomerCodePath"
                          label="Provider Customer Code Path"
                          disabled={requireTransform === 'yes' ? false : true}
                          className={classes.textField}
                          value={providerCustomerCodePath || ''}
                          onChange={e => handleProviderCustomerCodePathChange(e)}
                        ></TextField>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              ) : (
                ''
              )}
            </Box>
          </>
        ) : (
          <Box m={2}>
            <Typography>
              **Support for Tracing is only available for customers. For Actual set-up, engage with Freight Tracking
              team.
            </Typography>
          </Box>
        )}
      </DialogForm>
    </div>
  );
};
export default EnableServiceDialog;
